import { METHODS, request } from '../axiosInstances';

export default {
  options: ({ type = 'review' }) => request(METHODS.GET, `/${type}/options/`, {}),
};
